import * as React from "react";
import './marqueecard.css';

// Long, repeated strings so each scrolling copy is comfortably wider than the
// full-width marquee band on any reasonable screen. The seamless translate(-100%)
// loop only reads as continuous when one copy spans the whole visible width — a
// short string leaves a big empty gap sliding through the now full-width band.
const LEFT = "<-LEFT".repeat(22);
const RIGHT = "RIGHT->".repeat(22);

function MarqueeCard(props) {
    return (
        <React.Fragment>
            <div className="marquee-wrap">
                <div className="marquee-inner">
                    <span className="marquee-left">{LEFT}</span>
                    <span className="marquee-left">{LEFT}</span>
                </div>
                <div className="marquee-inner">
                    <span className="marquee-right">{RIGHT}</span>
                    <span className="marquee-right">{RIGHT}</span>
                </div>
                <div className="marquee-inner">
                    <span className="marquee-left">{LEFT}</span>
                    <span className="marquee-left">{LEFT}</span>
                </div>
                <div className="marquee-inner">
                    <span className="marquee-right">{RIGHT}</span>
                    <span className="marquee-right">{RIGHT}</span>
                </div>
                <div className="marquee-inner">
                    <span className="marquee-left">{LEFT}</span>
                    <span className="marquee-left">{LEFT}</span>
                </div>
                <div className="marquee-inner">
                    <span className="marquee-right">{RIGHT}</span>
                    <span className="marquee-right">{RIGHT}</span>
                </div>
                <div className="marquee-inner">
                    <span className="marquee-left">{LEFT}</span>
                    <span className="marquee-left">{LEFT}</span>
                </div>
                <div className="marquee-inner">
                    <span className="marquee-right">{RIGHT}</span>
                    <span className="marquee-right">{RIGHT}</span>
                </div>
                <div className="marquee-inner">
                    <span className="marquee-left">{LEFT}</span>
                    <span className="marquee-left">{LEFT}</span>
                </div>
                {/* <span className="marquee-right">{RIGHT}</span> */}
            </div>
        </React.Fragment>
    );
}

export default MarqueeCard;